import axios from "axios";
import * as Config from "../../Utils/Config";



export async function create_Quote(data) {
    try {
        const res = await axios.post(`${Config.base_url}create_quote`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

export async function get_Quote_Data(data) {
    try {
        const res = await axios.post(`${Config.base_url}get_quote`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

// All Email Template
export async function get_Email_Template(data) {
    try {
        const res = await axios.post(`${Config.base_url}getEmailTemplate`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

export async function get_Single_Package(data) {
    try {
        const res = await axios.post(`${Config.base_url}get_quote_ps`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

export async function get_Quote_Info(data) {
    try {
        const res = await axios.post(`${Config.base_url}getQuoteInfo`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

export async function get_Quote_Template(data) {
    try {
        const res = await axios.post(`${Config.base_url}getQuoteTemplate`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

export async function get_Template_Content(data) {
    try {
        const res = await axios.post(`${Config.base_url}gettemplatecontent`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}


export async function last_Five_Quote(data) {
    try {
        const res = await axios.post(`${Config.base_url}LastFiveQuotes`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

export async function delete_Quote(data) {
    try {
        const res = await axios.post(`${Config.base_url}deleteQuote`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

export async function convert_Quote(data) {
    try {
        const res = await axios.post(`${Config.base_url}convertQuote`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}


export async function get_AllQuotes(data) {
    try {
        const res = await axios.post(`${Config.base_url}getAllQuotes`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}















